import React, { useState, useEffect } from "react";
import { supabase } from "../supabase";
import "../styles/register.css";
import { friendlyAuthError } from "../lib/friendlyErrors";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("info");
  const [countdown, setCountdown] = useState(0);

  // عداد 30 ثانية
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleReset = async (e) => {
    e.preventDefault();
    if (countdown > 0) return; // يمنع الإرسال قبل انتهاء العداد
    const trimmedEmail = email.trim();

    setLoading(true);
    setMessage("");
    setMessageType("info");

    const { error } = await supabase.auth.resetPasswordForEmail(trimmedEmail, {
      redirectTo: `${window.location.origin}/reset-password-confirm`,
    });

    if (error) {
      console.error("Password reset email failed:", error);
      setMessageType("error");
      setMessage(friendlyAuthError(error, "We could not send the reset link right now. Please try again."));
    } else {
      setMessageType("success");
      setMessage(`Reset link sent to ${trimmedEmail}`);
      setCountdown(30); // يبدأ عداد 30 ثانية
    }

    setLoading(false);
  };

  return (
    <section className="auth-section">
      <div className="auth-box">
        <div className="auth-header">
          <div className="auth-badge">Al Jabriyah Commercial</div>
          <h2>Reset Password</h2>
          <p>Enter your email to receive a password reset link.</p>
        </div>

        {message && <div className={`toast ${messageType}`}>{message}</div>}

        <form className="auth-form" onSubmit={handleReset}>
          <div className="field">
            <span>Email</span>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button className="auth-btn" disabled={loading || countdown > 0}>
            {countdown > 0
              ? `Wait ${countdown}s`
              : loading
              ? "Sending..."
              : "Send Reset Link"}
          </button>
        </form>

        <div className="auth-footer">
          <a href="/login">Back to Login</a>
        </div>
      </div>
    </section>
  );
}

export default ResetPassword;
